module.exports = __webpack_public_path__ + "img/y.fe41ae0e.png";